import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ToastGlobalService } from 'src/app/layout/toast-global/toast-global.service';
import { AuthService } from 'src/app/services/auth.service';
import { TelemetryService } from 'src/app/shared/services/telemetry.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private static readonly OIDC_RETRY_KEY = 'oidcErrorRetry';

  constructor(
    private router: Router,
    private toastGlobalService: ToastGlobalService,
    private injector: Injector
  ) { }

  handleError(error: any): void {
    // Angular catches errors in its zone, so the SDK does not receive them through window.onerror.
    this.injector.get(TelemetryService).trackException(error);

    const env = environment.apiServer;
    const message = error?.message || '';

    if (message.includes('No matching state found in storage')) {
      const retryCount = parseInt(sessionStorage.getItem(GlobalErrorHandler.OIDC_RETRY_KEY) || '0', 10);
      if (retryCount < 1) {
        sessionStorage.setItem(GlobalErrorHandler.OIDC_RETRY_KEY, String(retryCount + 1));
        console.warn('OIDC state lost — restarting authentication');
        this.injector.get(AuthService).startAuthentication();
      } else {
        sessionStorage.removeItem(GlobalErrorHandler.OIDC_RETRY_KEY);
        console.error('OIDC state lost — repeated failure, logging out');
        this.injector.get(AuthService).logout();
      }
      return;
    }

    if (message.includes('Cannot match any routes.')) {
      this.toastGlobalService.show('The system cannot match your selected route.', { classname: 'error' });
      console.log(error);
      this.router.navigate(['']);
    }
    else {
      console.log(error);
      if (env.includes('dev') || env.includes('localhost')) {
        this.toastGlobalService.show(message.substring(0, 100) + "...", { classname: 'error' });
      }
    }
  }
}
